import { gql } from "@apollo/client";

export const createWebLensUpload = gql`
    mutation createWebLensUpload {
        createWebLensUpload {
            uploadRef
            packageUploadUrl
            logoUploadUrl
            packageMaxBytes
            logoMaxBytes
        }
    }
`;
